module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": []
    }
  }, [_c('div', {
    staticClass: "folders-breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Reports Index',
        params: {
          reset: true
        }
      }
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), (this.report) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'Reports View',
        params: {
          reportid: _vm.report.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.report.name))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('a', [_vm._v(_vm._s(_vm.addOrEdit) + " Summary")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [(_vm.report) ? _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject"
  }, [_c('strong', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.addOrEdit) + " Report Summary:")]), _vm._v(" " + _vm._s(_vm.report.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.edit),
      expression: "loading.edit"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.edit),
      expression: "!loading.edit"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "add-summary"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('add-summary.name')
    }
  }, [_c('label', {
    attrs: {
      "for": "formname"
    }
  }, [_vm._v("Summary Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.summaryName),
      expression: "summaryName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formname",
      "placeholder": "Summary Name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.summaryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.summaryName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('add-summary.name')),
      expression: "errors.has('add-summary.name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('add-summary.name')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('form-wizard', {
    attrs: {
      "title": "",
      "subtitle": "",
      "color": "#d09f23",
      "start-index": _vm.wizardStartIndex
    },
    on: {
      "on-complete": _vm.onComplete,
      "on-change": _vm.wizardTabChanged
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Filter Results",
      "icon": "fa fa-check-square-o"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.report) ? _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.report.data), function(form) {
    return _c('div', {
      staticClass: "list-group accordion"
    }, [_c('a', {
      staticClass: "accordion-toggle list-group-title collapsed",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#criteria-accordion",
        "href": '#collapse_f_' + form.form_id
      }
    }, [_vm._v(_vm._s(form.form_name)), _c('i', {
      staticClass: "fa"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'collapse_f_' + form.form_id
      }
    }, [_vm._l((form.fields), function(field) {
      return [(!_vm.isSharedFormPreviewType(field.field)) ? _c('div', {
        staticClass: "list-group-item",
        class: {
          'active': field == _vm.currentField
        },
        on: {
          "click": function($event) {
            return _vm.selectField(field)
          }
        }
      }, [_vm._v(_vm._s(field.label))]) : _vm._e()]
    })], 2)])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.currentField !== null) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('h5', [_vm._v("Edit: "), _c('strong', [_vm._v(_vm._s(_vm.currentField.label))])])]), _vm._v(" "), _c('div', {
    staticClass: "conditions-box"
  }, [_c('form', [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentConditions) ? [(_vm.getFieldType(_vm.currentField.field) === 'date') ? _vm._l((_vm.currentConditions.conditions), function(condition, idx) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('i', {
      staticClass: "fa fa-trash pull-right",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.removeCondition(idx)
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v("Date range:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.date),
        expression: "condition.date"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(condition, "date", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearVal(condition)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((_vm.dateConditions), function(field) {
      return _c('option', {
        domProps: {
          "value": field.type
        }
      }, [_vm._v(_vm._s(field.name))])
    })], 2), _vm._v(" "), (condition.date == 'birthmonth') ? _c('div', [_c('br'), _vm._v(" "), _c('label', [_vm._v("Month:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value),
        expression: "condition.value"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(condition, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((12), function(n) {
      return _c('option', {
        domProps: {
          "value": n
        }
      }, [_vm._v(_vm._s(n))])
    })], 2)]) : _vm._e(), _vm._v(" "), (['lessthan', 'greaterthan', 'lessorequal', 'greaterorequal'].includes(condition.date)) ? [_c('br'), _vm._v(" "), _c('date-picker', {
      attrs: {
        "prefix-class": "xmx",
        "placeholder": "Select Date",
        "lang": "en",
        "format": _vm.dateFormat
      },
      model: {
        value: (condition.value),
        callback: function($$v) {
          _vm.$set(condition, "value", $$v)
        },
        expression: "condition.value"
      }
    })] : _vm._e(), _vm._v(" "), (condition.date === 'between') ? [_c('br'), _vm._v(" "), _c('date-picker', {
      attrs: {
        "placeholder": "Select Date Range",
        "lang": "en",
        "range-separator": "-",
        "prefix-class": "xmx",
        "range": true,
        "format": _vm.dateFormat
      },
      model: {
        value: (condition.value),
        callback: function($$v) {
          _vm.$set(condition, "value", $$v)
        },
        expression: "condition.value"
      }
    })] : _vm._e(), _vm._v(" "), (idx + 1 < _vm.currentConditions.conditions.length) ? _c('hr') : _vm._e()], 2)
  }) : [_vm._l((_vm.currentConditions.conditions), function(condition, idx) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('i', {
      staticClass: "fa fa-trash pull-right",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.removeCondition(idx)
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v("Type:")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.type),
        expression: "condition.type"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(condition, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.clearVal(condition)
        }]
      }
    }, [_vm._l((_vm.conditionTypes), function(conditionType) {
      return _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v("\n                                  " + _vm._s(conditionType.name) + "\n                                ")])
    }), _vm._v(" "), _vm._l((_vm.emptyFilledConditionTypes), function(conditionType) {
      return (!['_creator_id', '_editor_id', '_casemgr_account', 'programs'].includes(_vm.getFieldType(_vm.currentField.field))) ? _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v("\n                                  " + _vm._s(conditionType.name) + "\n                                ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.numericConditionTypes), function(conditionType) {
      return (!['_creator_id', '_editor_id', '_casemgr_account', 'programs'].includes(_vm.getFieldType(_vm.currentField.field))) ? _c('option', {
        domProps: {
          "value": conditionType.type
        }
      }, [_vm._v("\n                                  " + _vm._s(conditionType.name) + "\n                                ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (!['unduplicated', 'between', 'isempty', 'isfilled', 'recent'].includes(condition.type)) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.currentField.field.substr(0,
        _vm.currentField.field.indexOf('-')) ==
      'rating' ? 'Value: ' :
      'Label: '))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value),
        expression: "condition.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "value": ""
      },
      domProps: {
        "value": (condition.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(condition, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (['between'].includes(condition.type)) ? _c('div', [_c('label', [_vm._v("From")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value[0]),
        expression: "condition.value[0]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (condition.value[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(condition.value, 0, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("To")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (condition.value[1]),
        expression: "condition.value[1]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (condition.value[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(condition.value, 1, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), (_vm.currentConditions.conditions.length > 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n                                If\n                                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentConditions.all),
      expression: "currentConditions.all"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentConditions, "all", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Any\n                                  ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("All\n                                  ")])]), _vm._v("\n                                the rules are matched.\n                              ")])]) : _vm._e()]] : _vm._e(), _vm._v(" "), (!['_manager_id', '_secondary_manager_id'].includes(_vm.getFieldType(_vm.currentField.field))) ? _c('div', {
    staticClass: "form-group margin-bottom-0"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewCondition()
      }
    }
  }, [_vm._v("+ Add New Condition")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Add Columns",
      "icon": "fa fa-columns",
      "before-change": _vm.onAddColumnsComplete
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.report) ? _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.report.data), function(form) {
    return _c('div', {
      staticClass: "list-group accordion"
    }, [_c('a', {
      staticClass: "accordion-toggle list-group-title collapsed",
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#criteria-accordion",
        "href": '#form-columns-collapse' + form.form_id
      }
    }, [_vm._v(_vm._s(form.form_name)), _c('i', {
      staticClass: "fa"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'form-columns-collapse' + form.form_id
      }
    }, [_vm._l((form.fields), function(field) {
      return (!_vm.inColumns(field) && !_vm.isSharedFormPreviewType(field.field)) ? _c('div', {
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            return _vm.addColumn(field)
          }
        }
      }, [_vm._v("\n                      " + _vm._s(field.label) + "\n                    ")]) : _vm._e()
    }), _vm._v(" "), (!_vm.inColumns({
      'field': 'total',
      'form_id': '_'
    })) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.addColumn({
            'field': 'total',
            'form_id': '_',
            'label': 'Total Count'
          })
        }
      }
    }, [_vm._v("\n                      Total Count\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.inColumns({
      'field': 'unduplicated',
      'form_id': '_'
    })) ? _c('div', {
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.addColumn({
            'field': 'unduplicated',
            'form_id': '_',
            'label': 'Unduplicated Count'
          })
        }
      }
    }, [_vm._v("\n                      Unduplicated Count\n                    ")]) : _vm._e()], 2)])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [
    [_c('span', {
      staticClass: "list-group-title"
    }, [_vm._v("Columns in Summary")]), _vm._v(" "), _c('draggable', {
      staticClass: "list-group",
      attrs: {
        "list": _vm.columns,
        "tag": "ul"
      }
    }, _vm._l((_vm.columns), function(column) {
      return _c('li', {
        key: column.order,
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            return _vm.removeSelectedColumn(column)
          }
        }
      }, [_vm._v(_vm._s(column.label) + "\n                    ")])
    }), 0)]
  ], 2)])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Setup Data",
      "icon": "fa fa-cogs",
      "before-change": _vm.onDataSetupComplete
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.report) ? _c('div', {
    staticClass: "col-md-6"
  }, [
    [_c('span', {
      staticClass: "list-group-title"
    }, [_vm._v("Columns in Summary")]), _vm._v(" "), _c('draggable', {
      staticClass: "list-group",
      attrs: {
        "list": _vm.columns,
        "tag": "ul"
      }
    }, _vm._l((_vm.columns), function(column) {
      return _c('li', {
        key: column.order,
        staticClass: "list-group-item",
        class: {
          'active': _vm.currentColumn && column.field === _vm.currentColumn.field
        },
        on: {
          "click": function($event) {
            return _vm.selectColumnForSetup(column)
          }
        }
      }, [_vm._v(_vm._s(column.label) + "\n                    ")])
    }), 0)]
  ], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "data-setup-box form-group"
  }, [(_vm.currentColumn) ? [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": _vm.currentColumn.label
    }
  }), _vm._v(" "), (!(['__total', '__unduplicated'].includes(_vm.currentColumn.field))) ? [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-10"
  }, [_c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "labels": true,
      "value": _vm.isBaseline(),
      "sync": true
    },
    on: {
      "change": function($event) {
        return _vm.onBaselineFieldChange(_vm.currentColumn, $event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Set as baseline field")])], 1), _vm._v(" "), (_vm.isBaseline() && _vm.multipleValuesFields.some(function (el) { return _vm.currentColumn.field.includes(el); })) ? _c('div', {
    staticClass: "margin-bottom-10"
  }, [_c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "labels": true,
      "value": _vm.showAllValuesForField(),
      "sync": true
    },
    on: {
      "change": function($event) {
        return _vm.onShowAllValuesForFieldChange(_vm.currentColumn, $event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Include all possible values")])], 1) : _vm._e(), _vm._v(" "), (_vm.isBaseline()) ? _c('div', [_c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "labels": true,
      "value": _vm.countNullValuesForField(),
      "sync": true
    },
    on: {
      "change": function($event) {
        return _vm.onCountNullValuesForFieldChange(_vm.currentColumn, $event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Count null values")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBaseline()) ? _c('div', [_c('hr'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "select-col-value"
    }
  }, [_vm._v("Values function")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentColumn.values_function),
      expression: "currentColumn.values_function"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-col-value"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentColumn, "values_function", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "concat"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sum"
    }
  }, [_vm._v("Sum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "avg"
    }
  }, [_vm._v("Average")])])]) : _vm._e()] : _vm._e()] : _vm._e()], 2)])])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Add Chart",
      "icon": "fa fa-bar-chart"
    }
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "data-setup-box"
  }, [_c('span', [_vm._v("Add Chart")]), _vm._v(" "), _c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "labels": true,
      "value": _vm.hasChart,
      "sync": true
    },
    on: {
      "change": _vm.onHasChartChange
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.hasChart) ? _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "chart-title"
    }
  }, [_vm._v("Chart Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.title),
      expression: "chart.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "chart-title",
      "placeholder": "Chart Title",
      "name": "chart-title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.chart.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chart, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "chart-type"
    }
  }, [_vm._v("Chart Types")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.type),
      expression: "chart.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "chart-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.chart, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "bar-horizontal"
    }
  }, [_vm._v("Bar Chart (Horizontal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bar-vertical"
    }
  }, [_vm._v("Bar Chart (Vertical)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "line"
    }
  }, [_vm._v("Line Chart")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pie"
    }
  }, [_vm._v("Pie Chart")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "chart-type"
    }
  }, [_vm._v("Labels (Y axis)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.labels),
      expression: "chart.labels"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "y-axis"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.chart, "labels", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.columns), function(column) {
    return _c('option', {
      domProps: {
        "value": column.field
      }
    }, [_vm._v(_vm._s(column.label))])
  }), 0)]), _vm._v(" "), (_vm.chart.type !== 'pie') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "chart-label-y"
    }
  }, [_vm._v("Label for Y axis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.labelY),
      expression: "chart.labelY"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "chart-label-y",
      "placeholder": "Label for Y axis",
      "name": "chart-y-axis-label",
      "type": "text"
    },
    domProps: {
      "value": (_vm.chart.labelY)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chart, "labelY", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.chart.type !== 'pie') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "chart-label-x"
    }
  }, [_vm._v("Label for X axis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chart.labelX),
      expression: "chart.labelX"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "chart-label-x",
      "placeholder": "Label for X axis",
      "name": "chart-x-axis-label",
      "type": "text"
    },
    domProps: {
      "value": (_vm.chart.labelX)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.chart, "labelX", $event.target.value)
      }
    }
  })]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.hasChart) ? _c('div', {
    staticClass: "data-setup-box"
  }, [_c('p', [_vm._v("Values")]), _vm._v(" "), _vm._l((_vm.columns), function(column, idx) {
    return _c('div', {}, [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_vm._v("\n                      " + _vm._s(column.label) + "\n                      "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.chart.dataSeries),
        expression: "chart.dataSeries"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": column.field,
        "checked": Array.isArray(_vm.chart.dataSeries) ? _vm._i(_vm.chart.dataSeries, column.field) > -1 : (_vm.chart.dataSeries)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.chart.dataSeries,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = column.field,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.chart, "dataSeries", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.chart, "dataSeries", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.chart, "dataSeries", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')]), _vm._v(" "), _c('hr', {
      staticClass: "chart-color",
      style: ({
        background: '#' + _vm.chartColors[idx % _vm.chartColors.length]
      })
    })])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2995b83a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportEditSummary.vue
// module id = 1588
// module chunks = 1